import { IonContent, IonTextarea, IonHeader, IonButtons, IonBackButton, IonPage, IonTitle, IonToolbar, IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonItem, IonButton, useIonViewDidEnter, IonInput, IonLabel, IonSelect, IonSelectOption, useIonRouter, useIonAlert } from '@ionic/react';
import './tidred.css';
import getApi from '../api';
import EnvironmentBadge from '../components/EnvironmentBadge';
import { useLocalStorage } from '../components/useLocalStorage';
import React from 'react';
import { useParams } from "react-router-dom";


const Tidred: React.FC = () => {

  const { id } = useParams<{ id: string }>();
  let [time, setTime] = useLocalStorage("tid", "");
  const router = useIonRouter();
  const [presentAlert] = useIonAlert();


  const api = getApi();

  useIonViewDidEnter(() => {
    api.get("/user/timeregister/"+id+"/")
      .then(res => {
        console.log(res.data)
        console.log(res.data.date)
        setTime(res.data)
      })

  });

function cal_time(){
  document.querySelectorAll('#check_in, #check_out').forEach(element => {
    element.addEventListener('change', function() {
      // Get the values of the view_start and view_stop inputs
      const start = (document.querySelector('#check_in') as HTMLInputElement).value;
      const stop = (document.querySelector('#check_out') as HTMLInputElement).value;
  
      // Convert the input values to timestamps
      const startTimestamp = new Date('1970-01-01T' + start + 'Z').getTime();
      const stopTimestamp = new Date('1970-01-01T' + stop + 'Z').getTime();
  
      // Calculate the time difference in milliseconds
      let diff = stopTimestamp - startTimestamp;
  
      // Convert the time difference to hours and minutes
      let hours = Math.floor(diff / (1000 * 60 * 60));
      let minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  
      if (minutes < 15) {
        minutes = 0;
      } else if (minutes >= 15 && minutes < 45) {
        minutes = 5;
      } else if (minutes >= 45 && minutes < 61) {
        minutes = 0;
        hours = hours + 1;
      }
  
      // Set the value of the view_hours input to the time difference
      (document.querySelector('#hours') as HTMLInputElement).value = hours + '.' + minutes;
    });
  });
}

async function deleteEntry() {
    presentAlert({
        header: 'Radera tid',
        message: 'Är du säker på att du vill radera den här tiden?',
        buttons: [
            {
                text: 'Avbryt',
                role: 'cancel',
            },
            {
                text: 'Radera',
                handler: async () => {
                    try {
                        const response = await api.delete(`/user/timeregister/${id}/`);
                        if (response.status === 204) {
                            router.goBack();
                        }
                    } catch (error) {
                        console.error('Error:', error);
                    }
                },
            },
        ],
    });
}

async function update() {

  // Create object
  const object = {
    "check_in": (document.querySelector("#check_in") as HTMLInputElement).value,
    "check_out": (document.querySelector("#check_out") as HTMLInputElement).value,
    "desc": (document.querySelector("#desc") as HTMLInputElement).value,
    "hours": (document.querySelector("#hours") as HTMLInputElement).value,
    "order_id": (document.querySelector("#order_id_edit") as HTMLInputElement).value,
    "traktamente": (document.querySelector("#traktamente") as HTMLInputElement).value,
    "edited": "True"
  }

  // Update the object
  try {
    const response = await api.patch(`/user/timeregister/${id}/`, object);

    if (response.status === 200) {
      router.goBack();
    }
  } catch (error) {
    console.error('Error:', error);
  }
}

  return (
    <IonPage placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
      <IonHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <IonToolbar color="primary" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonButtons slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonBackButton />
          </IonButtons>
          <IonTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Redigera Tid</IonTitle>
          <div slot="end" style={{paddingRight:'8px'}}><EnvironmentBadge /></div>
        </IonToolbar>
      </IonHeader>
    <IonContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
    <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
      <IonCardHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <IonCardTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonCardTitle>
      </IonCardHeader>

      <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonLabel position="stacked" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Datum</IonLabel>
          <IonInput type="date" value={time.date} disabled={true} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonInput>
        </IonItem>
        <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonLabel position="stacked" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Start</IonLabel>
          <IonInput debounce={500} onIonChange={(ev) => cal_time()} type="time" id="check_in" value={time.check_in} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonInput>
        </IonItem>
        <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonLabel position="stacked" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Stop</IonLabel>
          <IonInput debounce={500} onIonChange={(ev) => cal_time()} type="time" id="check_out" value={time.check_out} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonInput>
        </IonItem>
        <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonLabel position="stacked" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Arbetad Tid</IonLabel>
          <IonInput type="number" id="hours" value={time.hours} disabled={true} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonInput>
        </IonItem>
        <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonTextarea
                id='desc'
                placeholder="Beskrivning av arbetet"
                value={time.desc} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}                ></IonTextarea>
        </IonItem>
        <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonLabel position="stacked" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Ordernummer</IonLabel>
          <IonInput type="number" id="order_id_edit" value={time.order_id} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonInput>
        </IonItem>
        <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <IonSelect id="traktamente" placeholder='Välj Traktamente' value={time.traktamente} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonSelectOption value="" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Inget</IonSelectOption>
          <IonSelectOption value="Halv" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Halv</IonSelectOption>
          <IonSelectOption value="Hel" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Hel</IonSelectOption>
        </IonSelect>
      </IonItem>
      <IonButton onClick={() => update()} expand="block" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Spara</IonButton>
      <IonButton onClick={() => deleteEntry()} expand="block" color="danger" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Radera</IonButton>
      </IonCardContent>
    </IonCard>
    </IonContent>
    </IonPage>
  );
};

export default Tidred;


